// extracted by mini-css-extract-plugin
module.exports = {"columns":"General__columns___Cx5Yf","column":"General__column___EEeVn"};